import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Link, useNavigate } from 'react-router-dom';
import Sidebar from './components/Sidebar';
import Header from './components/Header';
import useAppLayout from './hooks/useAppLayout';
import API_URL from './api/config';
import { useQuery, useQueryClient } from '@tanstack/react-query';

import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import ReactModal from 'react-modal';

function PrintOrder() {
  const { menu, toggleMobileMenu } = useAppLayout();
  
  const navigate = useNavigate();
   const [backgroundModalOpen, setBackgroundModalOpen] = useState(false);
  
    const [selectedColor, setSelectedColor] = useState("");
   
  
    // Fetch background colors
    const { data: backgroundColor = [], isLoadingBc, isErrorBc } = useQuery({
      queryKey: ["backgroundColor"],
      queryFn: () =>
        axios
          .get(`${API_URL}/tree-background-color-api`, { withCredentials: true })
          .then((res) => res.data),
      staleTime: 0,
      cacheTime: Infinity,
    });
  
  
  
    const { data: familyNameData, isLoading, isError, refetch } = useQuery({
      queryKey: ['familyName'],
      queryFn: () =>
        axios.get(`${API_URL}/family-name-api`, { withCredentials: true })
          .then(res => res.data.family_name?.substring(0, 16) || ""),
      staleTime: 0,
      cacheTime: Infinity,
    });
    // local state for editing
  const [header, setHeader] = useState("");
  
  // keep header in sync when query loads
  useEffect(() => {
    if (familyNameData) {
      setHeader(familyNameData);
    }
  }, [familyNameData]);
  
  
     const { data: user, isLoadingP, isErrorP } = useQuery({
        queryKey: ['userDetails'],
        queryFn: () =>
          axios.get(`${API_URL}/user-details-api`, { withCredentials: true })
            .then(res => res.data),
        staleTime: 0,
        cacheTime: Infinity,
      });
    
      const [fullNames, setFullNames] = useState(
        `${user?.n_prefix || ""} ${user?.name || ""} ${user?.last_name || ""}`.trim()
      );
      const [phoneNumber, setPhoneNumber] = useState(user?.phone_number || "");
    
      const [email, setEmail] = useState(user?.email || "");
      
      useEffect(() => {
        if (user) {
          setFullNames(`${user.n_prefix || ""} ${user.name || ""} ${user.last_name || ""}`.trim());
          setPhoneNumber(user.phone_number || "");
          setEmail(user.email || "");
        }
      }, [user]);
  
  
  
    const { data: treeSize, isLoadingTs, isErrorTs } = useQuery({
      queryKey: ["treeSize"],
      queryFn: () =>
        axios
          .get(`${API_URL}/family-tree-size-api`, { withCredentials: true })
          .then((res) => res.data),
      staleTime: 0,
      cacheTime: Infinity,
    });
  
    const { data: pickupLocation, isLoadingLoc, isErrorLoc } = useQuery({
      queryKey: ["pickupLocation"],
      queryFn: () =>
        axios
          .get(`${API_URL}/pick-up-tree-location-api`, { withCredentials: true })
          .then((res) => res.data),
      staleTime: 0,
      cacheTime: Infinity,
    });
  
    
  
  
    //calculate
    const [selectedTree, setSelectedTree] = useState(null);
    const [copies, setCopies] = useState("1");
    const [selectedPickup, setSelectedPickup] = useState(null);
  
    // Calculate total
    /*const total =
    (Number(selectedTree?.amount) || 0) * copies +
    (Number(selectedPickup?.amount) || 0);*/
  
    const total =
    (Number(selectedTree?.amount) || 0) * (Number(copies) || 0) +
    (Number(selectedPickup?.amount) || 0);
  
  
  
   
  
  
    const [loading, setLoading] = useState(false);
  
    const validateForm = () => {
      if (!familyNameData.trim()) {
        toast.error("Header is required");
        return false;
      }
    
      if (!fullNames.trim()) {
        toast.error("Full names are required");
        return false;
      }
    
      if (!phoneNumber.trim()) {
        toast.error("Phone number is required");
        return false;
      }
  
      if (!email.trim()) {
        toast.error("Email is required");
        return false;
      }
    
      
      const phoneRegex = /^(?:\+254|0)[17]\d{8}$/;
      if (!phoneRegex.test(phoneNumber)) {
        toast.error("Enter a valid phone number (e.g. 0712345678 or +254712345678)");
        return false;
      }
    
      if (!selectedTree) {
        toast.error("Please select a tree size");
        return false;
      }
  
      if (!selectedColor) {
        toast.error("Please select a tree background color");
        return false;
      }
    
      if (!selectedPickup) {
        toast.error("Please select a pickup location");
        return false;
      }
    
      return true;
    };
  
    const handleSaveOrder = async () => {
  
      if (!validateForm()) return;
  
      setLoading(true);
    
      const orderData = {
        header: header,
        tree_size: selectedTree?.id || null,
        number_of_copies: copies,
        background_color: selectedColor,
        full_names: fullNames.trim(),
        phone_number: phoneNumber.trim(),
        email: email.trim(),
        pickup_location: selectedPickup?.id || null,
        total_amount: total,
      };
    
      try {
        const response = await axios.post(
          `${API_URL}/save-tree-order-api`,
          orderData,
          { withCredentials: true }
        );
    
        toast.success(response.data.message || "Tree Order Placed", {
          position: "top-right",
          autoClose: 3000,
        });
        
  
        navigate('/print-tree-preview');
  
      } catch (error) {
        toast.error("Error saving details");
        console.error(error);
      } finally {
        setLoading(false);
      }
    };
   
    //check if order exist
    const [order, setOrder] = useState(null);
    const [loadingOrder, setLoadingOrder] = useState(true);
    
    useEffect(() => {
      const fetchOrder = async () => {
        try {
          const response = await axios.get(`${API_URL}/get-tree-order-api`, {
            withCredentials: true,
          });
          setOrder(response.data.order); // either object or null
        } catch (error) {
          console.error("Error fetching tree order:", error);
        } finally {
          setLoadingOrder(false);
        }
      };
    
      fetchOrder();
    }, []);
    //end check if order exist
  
    if (isLoading) return( 
      <div className="loadingspinnerDiv">
    <div className="loadingspinner"></div>
  </div>
       );
    
    if (isError) return <p>Error loading data.</p>;
  


  return (
    <div className={`main-wrapper ${menu ? 'slide-nav': ''}`}>
            <Header onMenuClick={(value) => toggleMobileMenu()} />
            <Sidebar />
        <ToastContainer />

        <div className='page-wrapper'>
          <div className='content container-fluid'>


            
            
            <div className="d-flex align-items-center mb-3">
              {/* Back Button */}
              <Link to="/family-tree" className="btn btn-link p-0 me-3">
                <i
                  className="fa fa-arrow-left"
                  style={{ color: "#184A2C", fontSize: "20px" }}
                ></i>
              </Link>
            
              {/* Info Box */}
              <div className="flex-grow-1">
                {/*<div className="alert alert-info mb-0" role="alert">
                  <i className="fa fa-info-circle me-2"></i>
                  Place your tree order and complete it through the notification sent to you.
                </div>*/}
              </div>
            </div>
            
            
            
                      <div className='row mt-4'>
                      <div className='col-md-12'>
                      <div className="card">
                      <div className="card-body">
            
                        <div className='row'>
                          <div className='col-6 col-md-6'>
                         
                          Header
                          <input type="text" name="header"
                            value={header}
                            onChange={(e) => setHeader(e.target.value)} 
                          className="form-control"/>
                          </div>
            
                          <div className='col-6 col-md-6'>
                            Tree Size
            
                  <select
                    name="tree_size"
                    className="form-select"
                    onChange={(e) =>
                      setSelectedTree(
                        treeSize.find((s) => s.id === parseInt(e.target.value)) ?? null
                      )
                    }
                  >
                    <option value="">-- Select Tree Size --</option>
                    {(treeSize || []).map((size) => (
                      <option key={size.id} value={size.id}>
                        {size.tree_size} (KES {size.amount})
                      </option>
                    ))}
                  </select>
                                      
                            </div>
                          </div>
            
                          <div className='row mt-2'>
                            <div className='col-6 col-md-6'>
                            No. of Copies
                            <input
                              type="number"
                              name="number_of_copies"
                              className="form-control"
                              min="1"
                              value={copies}
                              onChange={(e) => setCopies(e.target.value)} // keep as string
                              onBlur={() => {
                                // ensure at least 1 when leaving input
                                if (!copies || Number(copies) < 1) setCopies("1");
                              }}
                            />
                            </div>
                            <div className='col-6 col-md-6'>
                              <label>Tree Background</label>
                            <button onClick={() => setBackgroundModalOpen(true)} class="btn btn-outline-primary btn-sm">Background Color</button>
            
                           
                                <input
                                  type="text"
                                  className="form-control-sm"
                                  value={selectedColor}
                                  readOnly
                                  style={{ backgroundColor: selectedColor, border: 'none' }}
                                />
                           
                            </div>
                            </div>
            
                            <div className='row mt-2'>
                            <label class="bold-600">Pick Up Details</label>
                            <div className="alert alert-warning mt-3" role="alert">
                              <i className="fa fa-info-circle me-2"></i>
                              Make sure your <strong>phone number</strong> or <strong>email</strong> are updated to be contacted for your order.
                            </div>
                            <hr />
                            <div className='col-6 col-md-6'>
                            
                            Names
                            <input type="text" name="full_names" value={fullNames}
                              onChange={(e) => setFullNames(e.target.value)}
                            className="form-control" placeholder="Names in full" />
                            </div>
            
                            <div className='col-6 col-md-6'>
                              Phone number
                            <input type="text" name="phone_number" value={phoneNumber}  
                            onChange={(e) => setPhoneNumber(e.target.value)}
                            className="form-control" placeholder="Enter phone number" />
                            </div>
            
                            </div>
            
            
                            <div className='row mt-2'>
            
                            <div className='col-6 col-md-6'>
                            Email
                            <input type="text" name="email" value={email}  
                            onChange={(e) => setEmail(e.target.value)}
                            className="form-control" placeholder="Enter email" />
                              </div>
                            
                            <div className='col-6 col-md-6'>
                            Pickup Location
            
                  <select
                    name="pickup_location"
                    className="form-select"
                    onChange={(e) =>
                      setSelectedPickup(
                        pickupLocation.find((s) => s.id === parseInt(e.target.value)) ?? null
                      )
                    }
                  >
                    <option value="">-- Select Location --</option>
                    {(pickupLocation || []).map((size) => (
                      <option key={size.id} value={size.id}>
                        {size.name} (KES {size.amount})
                      </option>
                    ))}
                  </select>
            
                            </div>
            
                            </div>
            
                            <div className='row mt-2'>
                            <div className='col-6 col-md-6'>
                            Total Amount
                            <input
                    type="text"
                    name="total_amount"
                    className="form-control"
                    value={`KES ${total}`}
                    readOnly
                  />
                            </div>
                            </div>
            
                            <div className='row mt-4'>
                            
                            <div className='col-6 col-md-6'>
            
                            <button onClick={handleSaveOrder} className='btn btn-primary' 
                            disabled={loading} >
                                {loading ? 'Updating...' : 'Update Details'}
                              </button>
                              
                            </div>
            
                            <div className='col-6 col-md-6'>
            
                            {!loadingOrder && order && (
                              <Link to="/print-tree-preview" className="btn btn-outline-primary">
                                Preview Tree
                              </Link>
                            )}
                            
                            </div>
                            </div>
            
                            <div className='row mt-4'>
                            <div className='col-12 col-md-12'>
                              <center>
                             
                              </center>
                           
                            </div>
                            </div>
            
            
            
                      </div>
                      </div>
                      </div>
                      </div>
            
            
            
            
                        <ReactModal isOpen={backgroundModalOpen} onRequestClose={() => setBackgroundModalOpen(false)} 
                                          className="Modal" overlayClassName="Overlay"
                                        >
                                          <div className="modal-header">
                                            <h5 className="modal-title">Select Background Color</h5>
                                            <button type="button" className="btn-close modalCloseButton" onClick={() => setBackgroundModalOpen(false)}></button>
                                          </div>
                              
                                          <div className="modal-body">
            
                                          {isLoadingBc && <p>Loading colors...</p>}
                                      {isErrorBc && <p>Error loading colors.</p>}
            
                                      <div className="row" style={{
                                                maxHeight: "300px",   
                                                overflowY: "auto",  
                                                overflowX: "hidden", 
                                              }}>
                        {(backgroundColor || []).map((color, index) => (
                          <div
                            key={index}
                            className="col-4 col-md-3 mb-3 d-flex flex-column align-items-center"
                          >
                            <div
                              style={{
                                width: "50px",
                                height: "50px",
                                backgroundColor: color.color_code,
                                border: "1px solid #ccc",
                                borderRadius: "8px",
                              }}
                            ></div>
                            <small className="mt-1">{color.color_name}</small>
                            <small>{color.color_code}</small>
                            <button
                              className="btn btn-sm btn-outline-primary mt-2"
                              onClick={() => {
                                setSelectedColor(color.color_code);
                                setBackgroundModalOpen(false);
                              }}
                            >
                              Use
                            </button>
                          </div>
                        ))}
                        </div>
                      
                              </div>
                          
                              <div className="modal-footer">
                            
                              
                            </div>
                              </ReactModal>
                              
                        
        
          </div>
        </div>
      </div>
    
  );
}

export default PrintOrder;
